<div class="row mb-3">
    <div class="col-12 col-lg-6">
        <span class="title16" translate>lblSellToCustomer</span>
        <button type="button" translate aria-label="Center Align" 
        class="btn btn-outline-primary ml-2" *ngIf="useAllowSellToBillTo"
        (click)="onChangeSellToBillToCustomer(1)" [ngbTooltip]="lblChangeSellToCustomer | translate" tooltipClass="custom-tooltip"
        [disabled]="appointmentCommonService.editAppointmentService.appointmentDetails.isFromArchive"> 
             <i class="fa-lg fa-pencil-alt fas"></i>
        </button>
        <div class="row" *ngIf="contactDetails">
            <div class="col-6 col-lg-6 col-xl-4">
                <div class="af-form-group">
                    <label translate>lblCustomerNumber</label>
                    <div class="lbl-info">
                        <input type="text" class="form-control" [value]="contactDetails.customerNo" disabled />
                    </div>
                </div>
            </div>
            <div class="col-6 col-lg-6 col-xl-4">
                <div class="af-form-group">
                    <label translate>lblName</label>
                    <div class="lbl-info">
                        <input type="text" class="form-control" [value]="contactDetails.customerName" disabled />
                    </div>
                </div>
            </div>
            <div class="col-6 col-lg-6 col-xl-4">
                <div class="af-form-group">
                    <label translate>lblAddress</label>
                    <div class="lbl-info">
                        <input type="text" class="form-control" [value]="contactDetails.address" disabled [(ngModel)]="contactDetails.address" (ngModelChange)="emitContactData()" />
                    </div>
                </div>
            </div>
            <div class="col-6 col-lg-6 col-xl-4">
                <div class="af-form-group">
                    <label translate>lblAddress2</label>
                    <div class="lbl-info">
                        <input type="text" class="form-control" [value]="contactDetails.address2" disabled [(ngModel)]="contactDetails.address2" (ngModelChange)="emitContactData()" />
                    </div>
                </div>
            </div>
            <div class="col-6 col-lg-6 col-xl-4">
                <div class="af-form-group">
                    <label translate>lblPostCode</label>
                    <div class="lbl-info">
                        <input type="text" class="form-control" [value]="contactDetails.postCode" disabled [(ngModel)]="contactDetails.postCode" (ngModelChange)="emitContactData()" />
                    </div>
                </div>
            </div>
            <div class="col-6 col-lg-6 col-xl-4">
                <div class="af-form-group">
                    <label translate>lblCity</label>
                    <div class="lbl-info">
                        <input type="text" class="form-control" [value]="contactDetails.city" disabled />
                    </div>
                </div>
            </div>
            <div class="col-6 col-lg-6 col-xl-4">
                <div class="af-form-group">
                    <label translate>lblMobile</label>
                    <div class="lbl-nfo">
                        <ngx-intl-tel-input [selectFirstCountry]= "false" [cssClass]="{'form-control': true}" [selectedCountryISO]="selectedSellCountryISO" [maxLength]="15" [phoneValidation]="false"
                        [separateDialCode]="true" [onlyCountries]="onlyCountries" [enablePlaceholder]="false" disabled
                        [(ngModel)]="contactDetails.mobileNo" #mobileNo="ngModel" (countryChange)="onCountryChange($event)"
                        (ngModelChange)="emitContactData()"></ngx-intl-tel-input>
                    </div>
                </div>
            </div>
            <div class="col-6 col-lg-6 col-xl-4">
                <div class="af-form-group">
                    <label translate>lblEmail</label>
                    <div class="lbl-nfo">
                        <input type="text" class="form-control" [value]="contactDetails.email" [(ngModel)]="contactDetails.email" maxlength="50" [disabled]="!editAppointmentService.isEdit" (ngModelChange)="emitContactData()" (change)="onEmailChange()" />
                    </div>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="contactDetails">
            <div class="col-12">
                <div class="af-form-group">
                    <label translate>lblRemark</label>
                    <div class="lbl-info">
                        <textarea class="form-control remark-highlight" [value]="contactDetails.customerRemark" disabled>
                        </textarea>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-12 col-lg-6 border-left">
        <span class="title16" translate>lblBillToCustomer</span> 
        <button type="button" translate aria-label="Center Align" 
        class="btn btn-outline-primary ml-2 ng-star-inserted" *ngIf="useAllowSellToBillTo"
        (click)="onChangeSellToBillToCustomer(0)" [ngbTooltip]="lblChangeBillToCustomer | translate" tooltipClass="custom-tooltip"
        [disabled]="appointmentCommonService.editAppointmentService.appointmentDetails.isFromArchive"> 
             <i class="fa-lg fa-pencil-alt fas"></i>             
        </button>           
        <div class="row" *ngIf="contactDetails">
            <div class="col-6 col-lg-6 col-xl-4">
                <div class="af-form-group">
                    <label translate>lblCustomerNumber</label>
                    <div class="lbl-info">
                        <input type="text" class="form-control" [value]="contactDetails.billtoCustomerNo" disabled />
                    </div>
                </div>
            </div>
            <div class="col-6 col-lg-6 col-xl-4">
                <div class="af-form-group">
                    <label translate>lblName</label>
                    <div class="lbl-info">
                        <input type="text" class="form-control" [value]="contactDetails.billToCustomerName" disabled />
                    </div>
                </div>
            </div>
            <div class="col-6 col-lg-6 col-xl-4">
                <div class="af-form-group">
                    <label translate>lblAddress</label>
                    <div class="lbl-info">
                        <input type="text" class="form-control" [value]="contactDetails.billToAddress" disabled [(ngModel)]="contactDetails.billToAddress" (ngModelChange)="emitContactData()" />
                    </div>
                </div>
            </div>
            <div class="col-6 col-lg-6 col-xl-4">
                <div class="af-form-group">
                    <label translate>lblAddress2</label>
                    <div class="lbl-info">
                        <input type="text" class="form-control" [value]="contactDetails.billToAddress2" disabled [(ngModel)]="contactDetails.billToAddress2" (ngModelChange)="emitContactData()" />
                    </div>
                </div>
            </div>
            <div class="col-6 col-lg-6 col-xl-4">
                <div class="af-form-group">
                    <label translate>lblPostCode</label>
                    <div class="lbl-info">
                        <input type="text" class="form-control" [value]="contactDetails.billToPostcode" disabled [(ngModel)]="contactDetails.billToPostcode" (ngModelChange)="emitContactData()" />
                    </div>
                </div>
            </div>
            <div class="col-6 col-lg-6 col-xl-4">
                <div class="af-form-group">
                    <label translate>lblCity</label>
                    <div class="lbl-info">
                        <input type="text" class="form-control" [value]="contactDetails.billToCity" disabled />
                    </div>
                </div>
            </div>
            <div class="col-6 col-lg-6 col-xl-4">
                <div class="af-form-group">
                    <label translate>lblMobile</label>
                    <div class="lbl-nfo">
                        <ngx-intl-tel-input [selectFirstCountry]= "false" [cssClass]="{'form-control': true}" [selectedCountryISO]="selectedBillToCountryISO" [maxLength]="15" [phoneValidation]="false" 
                        [separateDialCode]="true" [onlyCountries]="onlyCountries" [enablePlaceholder]="false" disabled
                        [(ngModel)]="contactDetails.billToMobile" (countryChange)="onCountryChange($event)"
                        (ngModelChange)="emitContactData()"></ngx-intl-tel-input>
                    </div>
                </div>
            </div>
            <div class="col-6 col-lg-6 col-xl-4">
                <div class="af-form-group">
                    <label translate>lblEmail</label>
                    <div class="lbl-nfo">
                        <input type="text" class="form-control" [value]="contactDetails.billToEmail" [(ngModel)]="contactDetails.billToEmail" maxlength="50" disabled (ngModelChange)="emitContactData()" />
                    </div>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="contactDetails">
            <div class="col-12">
                <div class="af-form-group">
                    <label translate>lblRemark</label>
                    <div class="lbl-info">
                        <textarea class="form-control remark-highlight" [value]="contactDetails.billToCustomerRemark" disabled>
                        </textarea>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-12 col-lg-6 pt-2" *ngIf="contactDetails && contactDetails.serviceContractCustomer">
        <span class="title16" translate>lblServiceContract</span>
        <div class="row" *ngIf="contactDetails">
            <table style="width: 75%;">
                <thead>
                    <th translate>lblCustomerNumber</th>
                    <th translate>lblCustomerName</th>
                    <th translate>lblContractStartDate</th>
                    <th translate>lblContractExpiryDate</th>
                    <th translate *ngIf="userRoleRightsDetails.canEdit">lblView</th>
                </thead>
                <tbody>
                    <tr *ngFor="let item of contactDetails.serviceContractCustomer;let i=index">
                        <td>{{item.customerNo}}</td>
                        <td>{{item.customerName}}</td>
                        <td>{{item.startDate | date:'shortDate' }}</td>
                        <td [ngStyle]="{'color': !contactDetails.isServiceContractVehicle ? 'red' : ''}">{{item.expiredDate | date:'shortDate' }}</td>
                        <td *ngIf="userRoleRightsDetails.canEdit">
                            <a class="btn btn-ico" (click)="viewCustomer(item)" ngbTooltip="{{'lblView' | translate}}">
                                <em class="far fa-eye fa-lg"></em>
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    
</div>